<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>
<style src="./jobs.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import JobItem from './JobItem'
  import Kununu from '@/components/modules/KununuModule'
  import SearchFilter from './SearchFilter'
  import AppPagination from '@/components/ui/AppPagination'

  export default {
    name: 'JobsPage',
    components: {
      AppPagination,
      JobItem,
      Kununu,
      SearchFilter,
    },
    metaInfo() {
      return {
        title: this.$t('meta.jobs.title'),
      }
    },
    data() {
      return {
        page: 1,
      }
    },
    computed: {
      ...mapState('jobs', [
        'jobs',
        'pagination',
        'filterActive',
      ]),
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page ? value.page : 1
        if (this.filterActive) {
          this.filterJobs({ page: this.page })
        } else {
          this.getJobs(this.page)
        }
      },
    },
    created() {
      this.page = this.$route.query.page || this.page
      this.getJobs(this.page)
    },
    destroyed() {
      this.clearJobs()
    },
    methods: {
      ...mapActions('jobs', [
        'getJobs',
        'filterJobs',
        'clearJobs',
        'resetFilter',
        'setFilterActive',
      ]),
      filterPositions(page = 1) {
        this.setFilterActive()
        if (parseInt(this.$route.query.page) !== parseInt(page)) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else if (this.filterActive) {
          this.filterJobs({ page: this.page })
        } else {
          this.getJobs(this.page)
        }
      },
      updateJobs(page = 1) {
        this.getJobs(page)
      },
    },
  }
</script>
